// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"397":"3dae804f","525":"e8430921","604":"80b37ad3","662":"a28d7ac4"}[chunkId] + ".chunk.js";
};